import { ModuleWithProviders, NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";

import { SignalrEffect } from "./signalr.effect";
import { createSignalrProvider, SIGNALR_CUSTOMER_TOKEN, SIGNALR_GROUP_TOKEN } from "./signalr.provider";

@NgModule({
	imports: [EffectsModule.forFeature([SignalrEffect])],
})
export class SignalrModule {
	static forRoot(): ModuleWithProviders<SignalrModule> {
		return {
			ngModule: SignalrModule,
			providers: [createSignalrProvider(SIGNALR_CUSTOMER_TOKEN), createSignalrProvider(SIGNALR_GROUP_TOKEN)],
		};
	}
}
